import type { ReactElement } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

/** Prefer this over HTML `title` for icon/button hints in the client UI. */
export function ActionTip({
  tip,
  children,
  placement = 'top',
  delay,
}: {
  tip: string;
  children: ReactElement;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  delay?: number | { show: number; hide: number };
}) {
  return (
    <OverlayTrigger
      placement={placement}
      delay={delay}
      overlay={<Tooltip id={`action-tip-${tip}`}>{tip}</Tooltip>}
    >
      {children}
    </OverlayTrigger>
  );
}
